import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSite = _resolveComponent("SelectSite")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SelectSite, {
      class: "step-one-container",
      onPick: _ctx.pick,
      selectedSite: _ctx.selectedSite,
      title: _ctx.$t('contact.page.site.search.label'),
      "export-contact": true,
      "inclure-termines": true
    }, null, 8, ["onPick", "selectedSite", "title"]),
    _createVNode(_component_ReglePastille, { cle: "contact.exportContacts" })
  ], 64))
}